module.exports = __webpack_public_path__ + "img/button-external.2990f545.png";